import { Box, Button } from "@mui/material";
import { type PackageFormState } from "../api-order-form";
import ApiOrderPackageRow from "./api-order-package-row";
import ApiOrderSection from "./api-order-section";

type ApiOrderPackagesSectionProps = {
  readonly packages: readonly PackageFormState[];
  readonly onPackageChange: (next: PackageFormState) => void;
  readonly onPackageRemove: (packageId: string) => void;
  readonly onPackageAdd: () => void;
};

/** Every package of the order, with the controls to add and remove rows. */
const ApiOrderPackagesSection = ({
  packages,
  onPackageChange,
  onPackageRemove,
  onPackageAdd,
}: ApiOrderPackagesSectionProps) => (
  <ApiOrderSection title="Packages">
    {packages.map((packageForm) => (
      <ApiOrderPackageRow
        key={packageForm.id}
        packageForm={packageForm}
        removeDisabled={packages.length === 1}
        onChange={onPackageChange}
        onRemove={onPackageRemove}
      />
    ))}
    <Box>
      <Button size="small" onClick={onPackageAdd}>
        Add package
      </Button>
    </Box>
  </ApiOrderSection>
);

export default ApiOrderPackagesSection;
